import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { toast } from 'react-toastify';
import Button from '../forms/Button';
import Input from '../forms/Input';
import { requestSaveContactInfo } from '../../actions/contactInfo';

class EditContactInfo extends React.Component {
  onSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const {
      requestSaveContactInfo, translate, destination, onSaved,
    } = this.props;

    const data = {};
    for (const [key, value] of formData.entries()) {
      data[key] = value;
    }

    requestSaveContactInfo(
      destination.id,
      JSON.stringify({ contactInfo: data }),
      (e) => {
        console.log(e);
        toast.error(translate('destination.contact_info_save_failed'));
      },
      () => onSaved(),
    );
  }

  render() {
    const { translate, contactInfo } = this.props;
    const { name, phone, email } = contactInfo || {};

    return (
      <form onSubmit={this.onSubmit.bind(this)}>

        <div>
          <div className="row">
            <div className="col-sm-12"><h5>{translate('destination.contact_info_name')}</h5></div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Input name="name" type="text" defaultValue={name} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12"><h5>{translate('destination.contact_info_phone')}</h5></div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Input name="phone" type="text" defaultValue={phone} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12"><h5>{translate('destination.contact_info_email')}</h5></div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Input name="email" type="text" defaultValue={email} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Button onClick={this.props.onCancel}>{translate('form.reset')}</Button>
          </div>
          <div className="col-sm-6">
            <Button>{translate('form.submit')}</Button>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    translate: getTranslate(locale),
    currentLanguage: activeLanguage?.code || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestSaveContactInfo,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditContactInfo);
